import React, {useState, useEffect} from 'react'
import PropTypes from 'prop-types'
import {Link as RouteLink} from 'react-router-dom'
import {
    Box,
    Text,
    Image,
    Link as NavLink
} from '@salesforce/retail-react-app/app/components/shared/ui'
import Video from '../../../components/page-designer/assets/hero/partials/video'

const LifeStyleImage = ({
    copyText,
    enableCopyTextUnderline = false,
    fontColor,
    backgroundColor,
    imageUrl,
    videoUrl,
    categoryUrl = '',
    alt
}) => {
    const isExternalDomain = categoryUrl?.indexOf('http') !== -1
    const wrapperProps = categoryUrl
        ? isExternalDomain
            ? {as: NavLink, href: categoryUrl}
            : {as: RouteLink, to: categoryUrl}
        : {}
    const underlineProps = enableCopyTextUnderline
        ? {textDecoration: 'underline', textUnderlineOffset: '4px'}
        : {}
    const [tileHeight, setTileHeight] = useState('450')

    const shouldDisplayVideo = typeof videoUrl !== 'undefined'

    useEffect(() => {
        let observer

        const interval = setInterval(() => {
            const element = document.getElementsByClassName('recommender-product-tile')[0]

            if (element) {
                setTileHeight(element.offsetHeight)

                observer = new ResizeObserver(() => {
                    setTileHeight(element.offsetHeight)
                })

                observer.observe(element)

                clearInterval(interval)
            }
        }, 100)

        return () => {
            clearInterval(interval)

            if (observer) {
                observer.disconnect()
            }
        }
    }, [])

    return (
        <Box data-is-not-orderable={false} className="tile-wrapper" position="relative">
            <Box data-testid="lifestyle" className="plp-lifestyle-tile">
                <Box
                    className="tile-box"
                    sx={{
                        '.video-container': {
                            height: `calc(${tileHeight}px - 44px)`
                        }
                    }}
                >
                    {shouldDisplayVideo ? (
                        <Video
                            desktopVideo={videoUrl}
                            mobileVideo={videoUrl}
                            videoDisableAutoPlay={true}
                            videoEnableSound={false}
                            videoAlt={copyText}
                            aspectRatio="310:465"
                        />
                    ) : (
                        <Box {...wrapperProps}>
                            <Image
                                width="100%"
                                height={`calc(${tileHeight}px - 44px)`}
                                objectFit="cover"
                                alt={alt}
                                src={imageUrl}
                            />
                        </Box>
                    )}
                    <Box
                        className="copy-text"
                        fontFamily="body"
                        fontSize="16px"
                        fontWeight="400"
                        display="flex"
                        justifyContent="center"
                        alignContent="center"
                        width="100%"
                        height="auto"
                        background={backgroundColor}
                    >
                        <Text
                            {...wrapperProps}
                            {...underlineProps}
                            color={fontColor}
                            padding="10px 0"
                        >
                            {copyText}
                        </Text>
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}

LifeStyleImage.propTypes = {
    copyText: PropTypes.string,
    enableCopyTextUnderline: PropTypes.string,
    fontColor: PropTypes.string,
    backgroundColor: PropTypes.string,
    imageUrl: PropTypes.string,
    videoUrl: PropTypes.string,
    alt: PropTypes.string,
    categoryUrl: PropTypes.any
}

export default LifeStyleImage
